/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/search-without-box': {
    width: 45,
    height: 45,
    viewBox: '0 0 45 45',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M5.315 5.315c-7.087 7.086-7.087 18.617 0 25.703 6.012 6.012 14.953 6.923 21.935 2.734 0 0 .505-.3.93.125l9.254 9.254c1.845 1.845 4.426 2.285 6.063.648l.282-.282c1.636-1.637 1.197-4.218-.649-6.063l-9.273-9.273c-.406-.406-.105-.91-.105-.91 4.188-6.983 3.278-15.924-2.734-21.936-7.086-7.087-18.617-7.087-25.703 0zM27.662 8.67c5.236 5.237 5.236 13.756 0 18.992-5.236 5.236-13.756 5.236-18.992 0-5.236-5.236-5.236-13.755 0-18.992 5.236-5.236 13.756-5.236 18.992 0z" _fill="#614789"/>'
  }
})
